<template>
    <div class="wrapper">
        <div class="content-container">
            <div class="stingy-card">
                <h2>🎉 The ABC's of Canadian Investment Accounts 🎉</h2>
                <p>Hello there, fellow investors! I'm Warm n Fluffy, your feline guide to the world of investments. Let's explore the different types of investment accounts in Canada, shall we?</p>
                <h3>Non-Registered Accounts:</h3>
                <p>Non-registered accounts are straightforward. No limits on investment, but gains are taxable. Remember, wise tax management is key!</p>
                <h3>TFSA (Tax-Free Savings Account):</h3>
                <p>The TFSA is like a sunny spot for your investments. Earn tax-free income and make withdrawals without taxes. It's perfect for both saving and investing!</p>
                <h3>FHSA (First Home Savings Account):</h3>
                <p>A new way to save for your first home. Contributions are tax-deductible, and withdrawals for your first home purchase are tax-free!</p>
                <h3>RRSP (Registered Retirement Savings Plan):</h3>
                <p>RRSPs are for the long term. Reduce your taxable income now, and pay taxes later in retirement, ideally at a lower rate.</p>
                <h3>LIF (Life Income Fund):</h3>
                <p>Think of LIFs as a cozy cat bed with rules. Convert your pension funds and receive a steady income in retirement, with minimum and maximum limits.</p>
                <h3>LIRA (Locked-In Retirement Account):</h3>
                <p>LIRAs are like a puzzle toy. You can't access your funds until retirement, making it a safe spot for your future savings.</p>
                <h3>RRIF (Registered Retirement Income Fund):</h3>
                <p>RRIFs are like unwinding a ball of yarn. Convert your RRSP to a RRIF in retirement and receive regular, taxable payments.</p>
                <h3>Pension (Defined Benefit Plan):</h3>
                <p>A pension, especially a defined benefit plan, is a rare treasure. It offers financial stability in retirement with a guaranteed income based on your salary and service years.</p>
                <p>Whether it's saving in a TFSA, investing in an RRSP, or unwinding in a RRIF, understanding these accounts will help you make the best choices for your financial journey. Stay curious, keep learning, and may your investments always land on their feet!</p>
                <p>Meow for now, 
                    <br>Warm n Fluffy 🐾</p>
                    <br>
                    <p>p.s. you can learn more about different investment accounts and test your skills in the gaming section of this app.</p>
            </div>
        </div>
    </div>
</template>


<script>
</script>



<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>